<template>
    <div class="theme-input hrm_input">
        <span v-if="isDisabled" class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
            {{ inputLabel }}
            <span v-if="inputRequired" class="leading-none text-sm font-bold text-red-600">*</span>
        </span>
        <label v-else class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
            {{ inputLabel }}
            <span v-if="inputRequired" class="leading-none text-sm font-bold text-red-600">*</span>
        </label>
        <span v-if="isDisabled" class="hrm_input_span_field block mt-2 w-full">
            {{ inputValue }}
        </span>
        <div v-else>
            <input v-model="inputValue" :type="inputType" :placeholder="inputPlaceholder"
                class="hrm_base_input_field mt-2 w-full" autocomplete="new-password" />
            <span v-if="inputError && inputRequired" class="hrm_input_error mt-2 text-xs text-red-600 theme-error-message">
                {{ inputError }}
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, watch, ref, onMounted } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    inputDisabled: {
        type: Boolean,
        default: false
    },
    inputPlaceholder: {
        type: String,
        default: ''
    },
    inputType: {
        type: String,
        default: 'text'
    },
    inputError: {
        type: String,
        default: null
    },
    inputLabel: {
        type: String,
        default: null
    },
    inputRequired: {
        type: Boolean,
        default: false
    },
});

const inputValue = ref();

const emit = defineEmits(['update:modelValue']);

const isDisabled = computed(() => props.inputDisabled);

// Sync modelValue
watch(() => inputValue.value, (val) => {
    emit('update:modelValue', val);
});

onMounted(() => {
    inputValue.value = props.modelValue;
})
</script>
<style>
.hrm_input_span_field,
.hrm_base_input_field {
    background-color: #35373b !important;
    border: 1px solid rgb(55 55 55) !important;
    color: #a3a3a3 !important;
    border-radius: 4px !important;
    font-size: 14px !important;
    padding: 8px 16px !important;
    height: 40px !important;
}
</style>